export default "__VITE_ASSET__938c7c99__"